import { CREATED_AT_KEY, CUSTOM_END_DATE_KEY, CUSTOM_START_DATE_KEY } from "../../escalatedPage.constants";

export const DATE_FILTER_KEYS = new Set<string>([CREATED_AT_KEY, CUSTOM_START_DATE_KEY, CUSTOM_END_DATE_KEY]);

export const EQUAL_OPERATOR = 'eq';
export const IN_OPERATOR = 'IN';